<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <div style="padding: 20px 20px">
      <!-- 顶部图片 -->
      <van-image
        width="100%"
        radius="10px"
        :src="require('../assets/picture/zbjb.png')"
      />
      <!-- 年份下拉表 -->
      <div>
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="selectYear"
              @change="selectChange($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in selectYearsColumns"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>
      <!-- 标题介绍 -->
      <h3 style="text-align: initial; color:#000; font-weight:900">
        <span style="color:#A1D4BF;">▋</span> {{ dataTitle }}
      </h3>

      <!-- 月份 -->
      <div class="cardCls" style="padding-top:5px;">
        <div class="reportTitle flex-between">
          <div style="color:#69A6F7;font-weight:900;"></div>
          <div>
            <select
              v-model="zbValue"
              @change="zbFn($event)"
              class="selectClass"
            >
              <option disabled value="0" selected>请选择</option>
              <option
                v-for="(item, index) in zbColumns"
                :key="index"
                :value="item"
              >
                第 {{ item.period }} 期
              </option>
            </select>
          </div>
        </div>
        <div class="flex-XY-center" style="flex-wrap:wrap">
          <div
            v-for="(item, i) in monthList"
            :key="i"
            class="monthClass"
            @click="zbOpenDetail(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>

      <!-- 月份 -->
      <!-- <div class="cardCls" style="padding-top:5px;">
        <div class="reportTitle flex-between">
          <div style="color:#A1D4BF;font-weight:900"><span>▌</span>简报</div>
          <div>
            <select
              v-model="jbValue"
              @change="jbFn($event)"
              class="selectClass"
            >
              <option disabled value="0" selected>请选择</option>
              <option
                v-for="(item, index) in jbColumns"
                :key="index"
                :value="item"
              >
                第 {{ item.period }} 期
              </option>
            </select>
          </div>
        </div>
        <div class="flex-XY-center" style="flex-wrap:wrap">
          <div
            v-for="(item, i) in monthList"
            :key="i"
            class="monthClass2"
            @click="jbOpenDetail(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div> -->
    </div>

    <!-- 表格图表弹窗 -->
    <van-popup
      v-model="showZtjz"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-picker
        title="期数"
        show-toolbar
        :columns="periodList"
        @confirm="onConfirm"
      >
        <template #option="option">
          <div
            style="display: flex; flex-direction: column; align-items: center;"
          >
            <div>第 {{ option.period }} 期</div>
          </div>
        </template>
      </van-picker>
    </van-popup>
    <div style="height: 100px"></div>

    <van-dialog
      v-model="showPdf"
      :showConfirmButton="false"
      allow-html
      width="100%"
      style="height:90%;"
      theme="default"
    >
      <div class="closeCLs" @click="showPdf = false">X</div>
      <div style="width:100%; height:100%;  overflow:auto;">
        <img width="100%" :src="pdfImage" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Table from './custom/Table.vue'
import { getDict } from '../api/zdqd.js'
import { ApiGetZBJB } from '../api/zsyz'
import { deepClone } from '../utils/deepClone'
import crudUser from '../api/user'
import GLOBAL from '../settings'

export default {
  name: 'zbjb',
  components: { Table },
  data() {
    return {
      // 后台获取的年份列表
      selectYearsColumns: [],
      // 获取今年
      selectYear:process.env.VUE_SELECT_YEAR,
      // selectYear: new Date().getFullYear(),
      zbValue: '0',
      zbColumns: [],
      jbValue: '0',
      jbColumns: [],
      // 是否显示背景暂无数据
      showZtjz: false,
      // 顶部标题数据
      dataTitle: '北仑区"六促六优"行动工作专报',
      // 月份
      monthList: [
        { label: '1月', value: 1 },
        { label: '2月', value: 2 },
        { label: '3月', value: 3 },
        { label: '4月', value: 4 },
        { label: '5月', value: 5 },
        { label: '6月', value: 6 },
        { label: '7月', value: 7 },
        { label: '8月', value: 8 },
        { label: '9月', value: 9 },
        { label: '10月', value: 10 },
        { label: '11月', value: 11 },
        { label: '12月', value: 12 }
      ],
      periodList: [],
      pdfImage: '',
      showPdf: false
    }
  },
  created() {
    // 通过后台配置的字典，拿到年份
    getDict('selectyear_list').then(res => {
      res.data.content.forEach(x => {
        this.selectYearsColumns.push(x.label)
      })
    })
    this.init(this.selectYear)
  },
  methods: {
    async init(selectYear) {
      const res = await ApiGetZBJB({ year: selectYear, type: '专报' })
      const res2 = await ApiGetZBJB({ year: selectYear, type: '简报' })
      this.zbColumns = res.data
      this.jbColumns = res2.data
    },
    async zbFn(e) {
      if (this.zbValue == 0) return

      dd.previewImage({
        current: GLOBAL.baseUrl + this.zbValue.title,
        urls: [GLOBAL.baseUrl + this.zbValue.title]
      })
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(alert(JSON.stringify(err)))
        })
      this.zbValue = 0
    },
    jbFn(e) {
      if (this.jbValue == 0) return

      dd.previewImage({
        current: GLOBAL.baseUrl + this.jbValue.title,
        urls: [GLOBAL.baseUrl + this.jbValue.title]
      })
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(alert(JSON.stringify(err)))
        })
      this.jbValue = 0
    },
    selectChange(e) {
      this.selectYear = e.target.value
      this.init(this.selectYear)
    },

    async zbOpenDetail(value) {
      const res = await ApiGetZBJB({
        year: this.selectYear,
        month: value,
        type: '专报'
      })
      if (res.data.length == 0) {
        alert('暂无数据')
        return
      }
      this.periodList = res.data
      this.showZtjz = true
    },
    async jbOpenDetail(value) {
      const res = await ApiGetZBJB({
        year: this.selectYear,
        month: value,
        type: '简报'
      })
      if (res.data.length == 0) {
        alert('暂无数据')
        return
      }
      this.periodList = res.data
      this.showZtjz = true
    },
    onConfirm(value, index) {
      console.log(`当前值：${value}, 当前索引：${index}`)
      // this.pdfImage = GLOBAL.baseUrl + value.title
      // console.log(this.pdfImage)
      // this.showPdf = true
      // this.showZtjz = false
      this.showZtjz = false
      dd.previewImage({
        current: GLOBAL.baseUrl + value.title,
        urls: [GLOBAL.baseUrl + value.title]
      })
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(alert(JSON.stringify(err)))
        })
    }
  }
}
</script>

<style scoped>
.monthClass,
.monthClass2 {
  background-color: #69a6f7;
  border-radius: 10px;
  width: 70px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  margin: 5px;
}
.monthClass2 {
  background-color: #a1d4bf;
}

.reportTitle {
  padding: 0 15px;
}
.vanDialogClass {
  text-align: initial;
  padding: 25px 20px;
}

.closeBtnClass {
  position: absolute;
  bottom: 20px;
  left: 40px;
  width: 80%;
  height: 45px;
  line-height: 45px;
  background-color: #a7d2f8;
  text-align: center;
  border-radius: 30px;
  color: #fff;
  letter-spacing: 16px;
}

.selectClass {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c4c8cf;
  padding: 4px 0px 4px 0px;
}
.tableBoxClass {
  margin-top: 20px;
  color: #000;
}
.tableTitleClass {
  width: 100%;
  background-color: #c6e6ff;
  font-weight: 700;
  text-align: center;
  color: #000;
  border-radius: 10px 10px 0 0;
  padding: 5px 0;
}

.tableCls {
  font-size: 14px;
  font-weight: 700;
  border: 1px solid #e3edf6;
  border-collapse: collapse;
  text-align: center;
}
.tableParent {
  height: 560px;
  overflow: auto;
}
table thead {
  position: sticky;
  top: 0;
  background-color: #fff;
}
table thead th,
table tbody td {
  border: 1px solid #e3edf6;
}
table tbody td {
  font-weight: 400;
  color: #000;
}
.remarkCls {
  color: #000;
  font-size: 12px;
  margin-top: 20px;
}
.remarkTextCls::before {
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #a7d2f8;
  margin-right: 10px;
}
.closeCLs {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #000;
  font-size: 20px;
}
.van-dialog >>> .van-dialog__content {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/zbjb.vue